import { WarnIcon } from "./CalendarIcons";
import styles from "./CalendarModule.module.css";

/** The day and week views' band when your calendar couldn't be loaded: why, and Try Again. */
export function CalendarLoadError({ message, onRetry }: Readonly<{ message: string; onRetry: () => void }>) {
  return (
    <div className={`${styles.band} ${styles.bandErr}`} role="alert">
      <div className={styles.bandTitle}>
        <WarnIcon />
        Couldn't Load Your Calendar
      </div>
      <div className={styles.bandText}>{message}</div>
      <div className={styles.bandActions}>
        <button type="button" className={`${styles.btn} ${styles.btnSecondary}`} onClick={onRetry}>
          Try Again
        </button>
      </div>
    </div>
  );
}
